// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.module.css */
.SeriesAdmin_container__Es3Yi {
    padding: 24px;
    min-height: 100vh;
    background-color: #000;
    color: #fff;
  }
  
  .SeriesAdmin_card__qj0Kx {
    background: linear-gradient(145deg, #1a1a1a, #262626);
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.05);
    overflow: hidden;
  }
  
  .SeriesAdmin_cardHeader__0InwP {
    padding: 24px 32px;
    background: rgba(255, 0, 0, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .SeriesAdmin_cardTitle__jhk8A {
    font-size: 28px;
    font-weight: 700;
    color: #fff;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .SeriesAdmin_cardContent__-m8v1 {
    padding: 24px 32px;
  }
  
  .SeriesAdmin_button__2Y86t {
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
    overflow: hidden;
  }
  
  .SeriesAdmin_button__2Y86t:hover {
    transform: translateY(-2px);
  }
  
  .SeriesAdmin_primaryButton__3CoUl {
    background: linear-gradient(135deg, #e11d48, #be123c);
    color: white;
  }
  
  .SeriesAdmin_primaryButton__3CoUl:hover {
    background: linear-gradient(135deg, #be123c, #9f1239);
    box-shadow: 0 4px 12px rgba(225, 29, 72, 0.3);
  }
  
  .SeriesAdmin_viewButton__BUx5p {
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: white;
  }
  
  .SeriesAdmin_viewButton__BUx5p:hover {
    background: linear-gradient(135deg, #1d4ed8, #1e40af);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
  }
  
  .SeriesAdmin_dangerButton__m0Sa4 {
    background: linear-gradient(135deg, #dc2626, #b91c1c);
    color: white;
  }
  
  .SeriesAdmin_dangerButton__m0Sa4:hover {
    background: linear-gradient(135deg, #b91c1c, #991b1b);
    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
  }
  
  .SeriesAdmin_table__lkrIT {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin-top: 20px;
  }
  
  .SeriesAdmin_table__lkrIT th,
  .SeriesAdmin_table__lkrIT td {
    padding: 16px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }
  
  .SeriesAdmin_table__lkrIT th {
    background-color: rgba(255, 255, 255, 0.02);
    font-weight: 600;
    color: #e11d48;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 14px;
  }
  
  .SeriesAdmin_table__lkrIT tr {
    transition: background-color 0.2s ease;
  }
  
  .SeriesAdmin_table__lkrIT tr:hover {
    background-color: rgba(255, 255, 255, 0.02);
  }
  
  .SeriesAdmin_actionButtons__Gu8h- {
    display: flex;
    gap: 8px;
  }
  
  .SeriesAdmin_iconButton__YrgFo {
    width: 36px;
    height: 36px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
  }
  
  .SeriesAdmin_statusBadge__POhGC {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    text-transform: capitalize;
    letter-spacing: 0.5px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  
  .SeriesAdmin_published__jGMmv {
    background: linear-gradient(135deg, #059669, #047857);
    color: white;
  }
  
  .SeriesAdmin_draft__BeBTA {
    background: linear-gradient(135deg, #9333ea, #7e22ce);
    color: white;
  }
  
  .SeriesAdmin_archived__Wk9cE {
    background: linear-gradient(135deg, #4b5563, #374151);
    color: white;
  }
  
  .SeriesAdmin_loading__UZqni {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    font-size: 18px;
    color: #e11d48;
    gap: 12px;
  }
  
  .SeriesAdmin_spinner__7FSWr {
    animation: SeriesAdmin_spin__7SQD0 1s linear infinite;
  }
  
  .SeriesAdmin_tableWrapper__LPPwR {
    overflow-x: auto;
    margin: 0 -32px;
    padding: 0 32px;
  }
  
  .SeriesAdmin_modal__TtNeT {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
  }
  
  .SeriesAdmin_modalContent__bEz4\\+ {
    background: linear-gradient(145deg, #1a1a1a, #262626);
    padding: 32px;
    border-radius: 16px;
    width: 100%;
    max-width: 500px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  }
  
  .SeriesAdmin_modalHeader__vU4j6 {
    margin-bottom: 20px;
  }
  
  .SeriesAdmin_modalTitle__GaMIt {
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 12px;
  }
  
  .SeriesAdmin_modalFooter__Fw39S {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 32px;
  }
  
  @keyframes SeriesAdmin_spin__7SQD0 {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  @media (max-width: 768px) {
    .SeriesAdmin_container__Es3Yi {
      padding: 16px;
    }
    
    .SeriesAdmin_cardHeader__0InwP {
      padding: 20px;
      flex-direction: column;
      gap: 16px;
      align-items: stretch;
    }
    
    .SeriesAdmin_cardContent__-m8v1 {
      padding: 20px;
    }
    
    .SeriesAdmin_table__lkrIT th,
    .SeriesAdmin_table__lkrIT td {
      padding: 12px;
    }
    
    .SeriesAdmin_button__2Y86t {
      width: 100%;
      justify-content: center;
    }
    
    .SeriesAdmin_actionButtons__Gu8h- {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }
    
    .SeriesAdmin_iconButton__YrgFo {
      width: 100%;
    }
  }
  @media (max-width: 388px) {
    .SeriesAdmin_searchContainer__QUrle {
      width: 215px !important;
    }
  
  } 

  /*Search Bar*/
  .SeriesAdmin_searchContainer__QUrle {
    display: flex;
    align-items: center;
    background: #f1f1f124;
    padding: 5px 10px;
    border-radius: 6px;
    width: 250px;
  }
  
  .SeriesAdmin_searchIcon__rF3wB {
    color: #666;
  }
  
  .SeriesAdmin_searchInput__HfBeV {
    border: none;
    background: transparent;
    padding: 5px;
    outline: none;
    flex: 1 1;
    font-size: 14px;
    color: white;
  }
  /* Pagination Styles - Add these to the existing SeriesAdmin.module.css file */
.SeriesAdmin_pagination__sAR9y {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  gap: 8px;
}

.SeriesAdmin_paginationButton__WflaI {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.SeriesAdmin_paginationButton__WflaI:hover:not(.SeriesAdmin_disabled__V78\\+i) {
  background: rgba(225, 29, 72, 0.2);
  border-color: rgba(225, 29, 72, 0.3);
  transform: translateY(-2px);
}

.SeriesAdmin_pageNumbers__3Jl-G {
  display: flex;
  align-items: center;
  gap: 8px;
}

.SeriesAdmin_pageNumber__0JGhY {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.SeriesAdmin_pageNumber__0JGhY:hover:not(.SeriesAdmin_activePage__cYg5f) {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.SeriesAdmin_activePage__cYg5f {
  background: linear-gradient(135deg, #e11d48, #be123c);
  border-color: transparent;
  box-shadow: 0 4px 12px rgba(225, 29, 72, 0.3);
  font-weight: 700;
  transform: translateY(-2px);
}

.SeriesAdmin_ellipsis__jNViO {
  color: rgba(255, 255, 255, 0.5);
  width: 20px;
  text-align: center;
}

.SeriesAdmin_disabled__V78\\+i {
  opacity: 0.4;
  cursor: not-allowed;
}

.SeriesAdmin_paginationInfo__X0ipi {
  text-align: center;
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.SeriesAdmin_noResults__eG5pD {
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  padding: 32px 0;
  font-style: italic;
}

@media (max-width: 768px) {
  .SeriesAdmin_pagination__sAR9y {
    margin-top: 24px;
  }
  
  .SeriesAdmin_paginationButton__WflaI,
  .SeriesAdmin_pageNumber__0JGhY {
    width: 36px;
    height: 36px;
  }
  
  .SeriesAdmin_pageNumbers__3Jl-G {
    gap: 6px;
  }
}

@media (max-width: 480px) {
  .SeriesAdmin_pagination__sAR9y {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/CSS/SeriesAdmin.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,qDAAqD;IACrD,mBAAmB;IACnB,yCAAyC;IACzC,2CAA2C;IAC3C,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,kDAAkD;IAClD,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,6CAA6C;EAC/C;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,6CAA6C;EAC/C;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,6CAA6C;EAC/C;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;IACb,gBAAgB;IAChB,kDAAkD;EACpD;;EAEA;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,cAAc;IACd,SAAS;EACX;;EAEA;IACE,qDAAkC;EACpC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,2CAA2C;IAC3C,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,oBAAoB;IACtB;;IAEA;MACE,aAAa;IACf;;IAEA;;MAEE,aAAa;IACf;;IAEA;MACE,WAAW;MACX,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,qCAAqC;IACvC;;IAEA;MACE,WAAW;IACb;EACF;EACA;IACE;MACE,uBAAuB;IACzB;;EAEF;;EAEA,aAAa;EACb;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,SAAO;IACP,eAAe;IACf,YAAY;EACd;EACA,8EAA8E;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* styles.module.css */\n.container {\n    padding: 24px;\n    min-height: 100vh;\n    background-color: #000;\n    color: #fff;\n  }\n  \n  .card {\n    background: linear-gradient(145deg, #1a1a1a, #262626);\n    border-radius: 16px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    overflow: hidden;\n  }\n  \n  .cardHeader {\n    padding: 24px 32px;\n    background: rgba(255, 0, 0, 0.1);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .cardTitle {\n    font-size: 28px;\n    font-weight: 700;\n    color: #fff;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n  \n  .cardContent {\n    padding: 24px 32px;\n  }\n  \n  .button {\n    padding: 10px 20px;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border: none;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .button:hover {\n    transform: translateY(-2px);\n  }\n  \n  .primaryButton {\n    background: linear-gradient(135deg, #e11d48, #be123c);\n    color: white;\n  }\n  \n  .primaryButton:hover {\n    background: linear-gradient(135deg, #be123c, #9f1239);\n    box-shadow: 0 4px 12px rgba(225, 29, 72, 0.3);\n  }\n  \n  .viewButton {\n    background: linear-gradient(135deg, #2563eb, #1d4ed8);\n    color: white;\n  }\n  \n  .viewButton:hover {\n    background: linear-gradient(135deg, #1d4ed8, #1e40af);\n    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n  }\n  \n  .dangerButton {\n    background: linear-gradient(135deg, #dc2626, #b91c1c);\n    color: white;\n  }\n  \n  .dangerButton:hover {\n    background: linear-gradient(135deg, #b91c1c, #991b1b);\n    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);\n  }\n  \n  .table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    margin-top: 20px;\n  }\n  \n  .table th,\n  .table td {\n    padding: 16px;\n    text-align: left;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  }\n  \n  .table th {\n    background-color: rgba(255, 255, 255, 0.02);\n    font-weight: 600;\n    color: #e11d48;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    font-size: 14px;\n  }\n  \n  .table tr {\n    transition: background-color 0.2s ease;\n  }\n  \n  .table tr:hover {\n    background-color: rgba(255, 255, 255, 0.02);\n  }\n  \n  .actionButtons {\n    display: flex;\n    gap: 8px;\n  }\n  \n  .iconButton {\n    width: 36px;\n    height: 36px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n  }\n  \n  .statusBadge {\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 13px;\n    font-weight: 600;\n    text-transform: capitalize;\n    letter-spacing: 0.5px;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n  }\n  \n  .published {\n    background: linear-gradient(135deg, #059669, #047857);\n    color: white;\n  }\n  \n  .draft {\n    background: linear-gradient(135deg, #9333ea, #7e22ce);\n    color: white;\n  }\n  \n  .archived {\n    background: linear-gradient(135deg, #4b5563, #374151);\n    color: white;\n  }\n  \n  .loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 40px;\n    font-size: 18px;\n    color: #e11d48;\n    gap: 12px;\n  }\n  \n  .spinner {\n    animation: spin 1s linear infinite;\n  }\n  \n  .tableWrapper {\n    overflow-x: auto;\n    margin: 0 -32px;\n    padding: 0 32px;\n  }\n  \n  .modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.8);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 20px;\n  }\n  \n  .modalContent {\n    background: linear-gradient(145deg, #1a1a1a, #262626);\n    padding: 32px;\n    border-radius: 16px;\n    width: 100%;\n    max-width: 500px;\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);\n  }\n  \n  .modalHeader {\n    margin-bottom: 20px;\n  }\n  \n  .modalTitle {\n    font-size: 24px;\n    font-weight: 700;\n    color: #fff;\n    margin-bottom: 12px;\n  }\n  \n  .modalFooter {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 32px;\n  }\n  \n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .container {\n      padding: 16px;\n    }\n    \n    .cardHeader {\n      padding: 20px;\n      flex-direction: column;\n      gap: 16px;\n      align-items: stretch;\n    }\n    \n    .cardContent {\n      padding: 20px;\n    }\n    \n    .table th,\n    .table td {\n      padding: 12px;\n    }\n    \n    .button {\n      width: 100%;\n      justify-content: center;\n    }\n    \n    .actionButtons {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n    }\n    \n    .iconButton {\n      width: 100%;\n    }\n  }\n  @media (max-width: 388px) {\n    .searchContainer {\n      width: 215px !important;\n    }\n  \n  } \n\n  /*Search Bar*/\n  .searchContainer {\n    display: flex;\n    align-items: center;\n    background: #f1f1f124;\n    padding: 5px 10px;\n    border-radius: 6px;\n    width: 250px;\n  }\n  \n  .searchIcon {\n    color: #666;\n  }\n  \n  .searchInput {\n    border: none;\n    background: transparent;\n    padding: 5px;\n    outline: none;\n    flex: 1;\n    font-size: 14px;\n    color: white;\n  }\n  /* Pagination Styles - Add these to the existing SeriesAdmin.module.css file */\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 32px;\n  gap: 8px;\n}\n\n.paginationButton {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #fff;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.paginationButton:hover:not(.disabled) {\n  background: rgba(225, 29, 72, 0.2);\n  border-color: rgba(225, 29, 72, 0.3);\n  transform: translateY(-2px);\n}\n\n.pageNumbers {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pageNumber {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #fff;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n\n.pageNumber:hover:not(.activePage) {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-2px);\n}\n\n.activePage {\n  background: linear-gradient(135deg, #e11d48, #be123c);\n  border-color: transparent;\n  box-shadow: 0 4px 12px rgba(225, 29, 72, 0.3);\n  font-weight: 700;\n  transform: translateY(-2px);\n}\n\n.ellipsis {\n  color: rgba(255, 255, 255, 0.5);\n  width: 20px;\n  text-align: center;\n}\n\n.disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.paginationInfo {\n  text-align: center;\n  margin-top: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 14px;\n}\n\n.noResults {\n  text-align: center;\n  color: rgba(255, 255, 255, 0.6);\n  padding: 32px 0;\n  font-style: italic;\n}\n\n@media (max-width: 768px) {\n  .pagination {\n    margin-top: 24px;\n  }\n  \n  .paginationButton,\n  .pageNumber {\n    width: 36px;\n    height: 36px;\n  }\n  \n  .pageNumbers {\n    gap: 6px;\n  }\n}\n\n@media (max-width: 480px) {\n  .pagination {\n    flex-wrap: wrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SeriesAdmin_container__Es3Yi`,
	"card": `SeriesAdmin_card__qj0Kx`,
	"cardHeader": `SeriesAdmin_cardHeader__0InwP`,
	"cardTitle": `SeriesAdmin_cardTitle__jhk8A`,
	"cardContent": `SeriesAdmin_cardContent__-m8v1`,
	"button": `SeriesAdmin_button__2Y86t`,
	"primaryButton": `SeriesAdmin_primaryButton__3CoUl`,
	"viewButton": `SeriesAdmin_viewButton__BUx5p`,
	"dangerButton": `SeriesAdmin_dangerButton__m0Sa4`,
	"table": `SeriesAdmin_table__lkrIT`,
	"actionButtons": `SeriesAdmin_actionButtons__Gu8h-`,
	"iconButton": `SeriesAdmin_iconButton__YrgFo`,
	"statusBadge": `SeriesAdmin_statusBadge__POhGC`,
	"published": `SeriesAdmin_published__jGMmv`,
	"draft": `SeriesAdmin_draft__BeBTA`,
	"archived": `SeriesAdmin_archived__Wk9cE`,
	"loading": `SeriesAdmin_loading__UZqni`,
	"spinner": `SeriesAdmin_spinner__7FSWr`,
	"spin": `SeriesAdmin_spin__7SQD0`,
	"tableWrapper": `SeriesAdmin_tableWrapper__LPPwR`,
	"modal": `SeriesAdmin_modal__TtNeT`,
	"modalContent": `SeriesAdmin_modalContent__bEz4+`,
	"modalHeader": `SeriesAdmin_modalHeader__vU4j6`,
	"modalTitle": `SeriesAdmin_modalTitle__GaMIt`,
	"modalFooter": `SeriesAdmin_modalFooter__Fw39S`,
	"searchContainer": `SeriesAdmin_searchContainer__QUrle`,
	"searchIcon": `SeriesAdmin_searchIcon__rF3wB`,
	"searchInput": `SeriesAdmin_searchInput__HfBeV`,
	"pagination": `SeriesAdmin_pagination__sAR9y`,
	"paginationButton": `SeriesAdmin_paginationButton__WflaI`,
	"disabled": `SeriesAdmin_disabled__V78+i`,
	"pageNumbers": `SeriesAdmin_pageNumbers__3Jl-G`,
	"pageNumber": `SeriesAdmin_pageNumber__0JGhY`,
	"activePage": `SeriesAdmin_activePage__cYg5f`,
	"ellipsis": `SeriesAdmin_ellipsis__jNViO`,
	"paginationInfo": `SeriesAdmin_paginationInfo__X0ipi`,
	"noResults": `SeriesAdmin_noResults__eG5pD`
};
export default ___CSS_LOADER_EXPORT___;
